import { render, staticRenderFns } from "./DuaMessageRevisionSelect.vue?vue&type=template&id=19a49b1a"
import script from "./DuaMessageRevisionSelect.vue?vue&type=script&lang=js"
export * from "./DuaMessageRevisionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports